import Vue from 'vue';
import VueI18n from 'vue-i18n';
import de from '@/i18n/messages/de';
import en from '@/i18n/messages/en';

Vue.use(VueI18n);

// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: 'de', // set locale
  messages: {de, en},
  silentTranslationWarn: true,
});

// Hot updates
if (module.hot) {
  module.hot.accept(['@/i18n/messages/en', '@/i18n/messages/de'], function() {
    i18n.setLocaleMessage('en', en);
    i18n.setLocaleMessage('de', de);
    // Or the following hot updates via $i18n property
    // app.$i18n.setLocaleMessage('en', require('./en').default)
    // app.$i18n.setLocaleMessage('ja', require('./ja').default)
  });
}

export default i18n;
